import styled from 'styled-components';
import { getColorAlias } from '../../../../utils/index.js';

const Wrapper = styled.div `
  display: flex;
  width: 312px;
  background-color: ${getColorAlias('containerDefault')};
  box-shadow: ${(props) => props.theme.elevation.e3};
  border-radius: ${(props) => props.theme.radius.roundedB};
  font-family: ${(props) => props.theme.font.familyPrimary};
`;

export { Wrapper };
